import { h } from 'preact';
import * as BaseComp from 'base/bolt/boltApp.js';
// import s from 'base/bolt/boltApp.sss';

export default class BoltApp extends BaseComp.default {
	constructor(props) {
		super(props);
		this.fadeInBgAudio = this.fadeInBgAudio.bind(this);
		this.fadeOutBgAudio = this.fadeOutBgAudio.bind(this);
	}

	componentDidUpdate(prevProps, prevState) {
		super.componentDidUpdate(prevProps, prevState);
		if (prevState.appState.activePage !== this.state.appState.activePage) {
			const activePage = this.state.appState.activePage;
			const isInMainScroll = activePage === 'boltHome' || this.state.appState.appData.pages[activePage].section;
			if (isInMainScroll) {
				this.fadingInBgAudio = true;
				this.fadingOutBgAudio = false;
				this.fadeInBgAudio();
			} else {
				this.fadingInBgAudio = false;
				this.fadingOutBgAudio = true;
				this.fadeOutBgAudio();
			}
		}
	}

	componentWillUnmount() {
		super.componentWillUnmount();
		if (this.fadeInBgAudioTimer) {
			window.clearTimeout(this.fadeInBgAudioTimer);
		}
		if (this.fadeOutBgAudioTimer) {
			window.clearTimeout(this.fadeOutBgAudioTimer);
		}
	}

	fadeInBgAudio() {
		if (this.fadingOutBgAudio) return;
		if (this.$bgVideo.volume < 1) {
			this.$bgVideo.volume = Math.min(this.$bgVideo.volume + 0.1, 1);
			this.fadeInBgAudioTimer = setTimeout(this.fadeInBgAudio, 100);
		}
	}
	
	fadeOutBgAudio() {
		if (this.fadingInBgAudio) return;
		if (this.$bgVideo.volume > 0) {
			this.$bgVideo.volume = Math.max(this.$bgVideo.volume - 0.1, 0);
			this.fadeOutBgAudioTimer = setTimeout(this.fadeOutBgAudio, 100);
		}
	}
}
